import React from 'react'
import Navbar from 'components/category/navbar'
import Category from 'components/category/produk'

export default function category() {
    return (
        <>
            <Navbar />
            <br />
            <Category tolink="ber_detils" />
            <br /><br />
        </>
    )
}
